import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { MutateOptions, useMutation, useQueryClient } from 'react-query';

import { tableConstants } from '..';

export const useTableSave = <T extends tableConstants.Keys>() => {
  const qc = useQueryClient();

  const { mutate, mutateAsync, ...data } = useMutation(
    async (data: { key: T; value: tableConstants.Defaults[T]; allUser?: boolean }) => {
      qc.setQueryData([tableConstants.queryKeys.TABLE, data.key], () => JSON.stringify(data?.value));

      const res = await $api.post('/v1/table', {
        ...data,
        value: JSON.stringify(data?.value)
      });

      return res?.data?.data;
    },
    {
      onError: async (props, { key }) => {
        await qc.invalidateQueries([tableConstants.queryKeys.TABLE, key]);
        baseErrorHandler(props);
      }
    }
  );

  return {
    ...data,
    mutate: <T2 extends T>(
      v: { key: T2; value: tableConstants.Defaults[T2]; allUser?: boolean },
      o?: MutateOptions<any, unknown, { key: T2; value: tableConstants.Defaults[T2]; allUser?: boolean }, unknown>
      // @ts-expect-error
    ) => mutate(v, o),
    mutateAsync: async <T2 extends T>(
      v: { key: T2; value: tableConstants.Defaults[T2]; allUser?: boolean },
      o?: MutateOptions<any, unknown, { key: T2; value: tableConstants.Defaults[T2]; allUser?: boolean }, unknown>
      // @ts-expect-error
    ) => mutateAsync(v, o)
  };
};
